var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-cascader',{attrs:{"options":_vm.options,"placeholder":_vm.placeholder},on:{"change":_vm.onChange},model:{value:(_vm.sValue),callback:function ($$v) {_vm.sValue=$$v},expression:"sValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }